import { Sparkles } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { KnowledgeGraph } from "@/components/knowledge/KnowledgeGraph";
import { PATHWAYS } from "@/components/knowledge/graphData";

const ROLE = {
  science: "Explains how the natural and physical world works.",
  social: "Explores people, places, the past and how communities make decisions.",
  engineering: "Designs, builds and tests solutions to real problems.",
  critical: "Weighs evidence, reasons clearly and considers other perspectives.",
};

export const KnowledgeMapSection = () => (
  <section className="section-y" aria-labelledby="kg-title" data-testid="knowledge-map-section">
    <div className="container-x">
      <SectionHeading id="kg-title" eyebrow="Connected knowledge" title="Build Your Knowledge Map"
        intro="Students build deep knowledge within four learning pathways, then connect it through real-world themes such as climate change, human health and sustainable cities." />
      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {PATHWAYS.map((p) => (
          <li key={p.id} className="card-soft flex items-start gap-3 p-5" data-testid={`pathway-summary-${p.id}`}>
            <span className="mt-1 h-3 w-3 shrink-0 rounded-full" style={{ background: p.stroke }} aria-hidden="true" />
            <div><p className="font-heading text-lg font-semibold">{p.title}</p><p className="mt-1 text-sm text-ink-soft">{ROLE[p.id]}</p></div>
          </li>
        ))}
      </ul>
      <div className="mt-10"><KnowledgeGraph /></div>
      <KnowledgeVision />
    </div>
  </section>
);

const KnowledgeVision = () => (
  <div className="mt-5" data-testid="knowledge-vision-section">
      <Reveal>
        <div className="flex items-start gap-4 rounded-card bg-lavender/60 p-7 sm:p-8" data-testid="knowledge-map-vision">
          <Sparkles className="mt-1 h-6 w-6 shrink-0" aria-hidden="true" />
          <div>
            <h3 className="text-2xl font-semibold">Aiming Real life: personal knowledge maps</h3>
            <p className="mt-2 max-w-3xl leading-relaxed text-ink">
              Our future vision is a personalised knowledge map for every student, growing as they explore new concepts and make new
              connections, so learners and families can see their journey at a glance. This is a direction we are developing, not a
              current feature.
            </p>
          </div>
        </div>
      </Reveal>
  </div>
);
